<template>
    <div>

        <PageHeader>
            {{ $t('settingsGdzieKupicTo') }}
            <template #side>
                <ButtonIcon @click="$router.push({ name: 'ProductLandingPageSettings' })">{{ $t('goBack') }}</ButtonIcon>
            </template>
            <template #bottom>
                <div class="d-flex flex-wrap gap-3">
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        label-class="text-wrap"
                        href="https://getbuybox.com/gdziekupic-to"
                        target="_blank"
                        variant="link"
                        class="p-0 flex-wrap"
                    >
                        {{ $t('learnMoreAboutThePersonalizationOfTheProductPage') }}
                    </ButtonIcon>
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        label-class="text-wrap"
                        href="https://getbuybox.com/konfiguracje/"
                        target="_blank"
                        variant="link"
                        class="p-0 flex-wrap"
                    >
                        {{ $t('checkWhatConfigurationsAreAndHowToUseThem') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <ErrorMessage :value="error" :dismissible="false" />

        <Card v-if="!landingPage && loading" :loading="loading" />

        <Card v-if="landingPage" :loading="loading" :overlay="!!landingPage">
            <div class="grid-template">
                <div class="label">{{ $t('website') }}</div>
                <div v-if="landingPage.space" class="value">{{ landingPage.space.name }}</div>
            </div>
        </Card>

        <div v-if="landingPage" class="d-flex gap-4">

            <Card :loading="loading" :header="$t('settings')" :sub-header="$t('personalizeYourTargetPageAppearanceGdziekupicTo')" overlay class="d-flx flex-column flex-grow-1 flex-basis-0">

                <FormValidator
                    id="form-group-favicon"
                    class="d-flex flex-column flex-grow-1"
                    :validator="$v.formImages.favicon"
                    form-group
                    :label="$t('favicon')"
                    v-slot="slotProps"
                >
                    <div class="d-flex gap-2">
                        <FormFile
                            id="form-favicon"
                            v-model="formImages.favicon"
                            accept="image/*"
                            show-thumbnails
                            :state="slotProps.state"
                            :disabled="saving"
                            :loading="requestImages.getLoading()"
                        />
                        <b-modal ref="formImagesFavicon" centered hide-footer hide-header body-class="text-center d-flex justify-content-center align-items-center height-min-200">
                            <ImageLoader v-if="landingPage" :src="landingPage.favicon" image-class="w-auto" error-class="w-auto" style="max-width: 100%;" />
                        </b-modal>
                        <ImageLoader
                            v-if="landingPage"
                            :src="landingPage.favicon"
                            class="my-auto cursor-pointer"
                            height="40px"
                            width="40px"
                            @click.native="$refs.formImagesFavicon.show()"
                        />
                    </div>
                </FormValidator>

                <FormValidator
                    id="form-group-logo"
                    class="d-flex flex-column flex-grow-1"
                    :validator="$v.formImages.logo"
                    form-group
                    :label="$t('logo')"
                    v-slot="slotProps"
                >
                    <div class="d-flex gap-2">
                        <FormFile
                            id="form-logo"
                            v-model="formImages.logo"
                            accept="image/*"
                            show-thumbnails
                            :state="slotProps.state"
                            :disabled="saving"
                            :loading="requestImages.getLoading()"
                        />
                        <b-modal ref="formImagesLogo" centered hide-footer hide-header body-class="text-center d-flex justify-content-center align-items-center height-min-200">
                            <ImageLoader v-if="landingPage" :src="landingPage.logo" image-class="w-auto" error-class="w-auto" style="max-width: 100%;" />
                        </b-modal>
                        <ImageLoader
                            v-if="landingPage"
                            :src="landingPage.logo"
                            class="my-auto cursor-pointer"
                            height="40px"
                            width="40px"
                            @click.native="$refs.formImagesLogo.show()"
                        />
                    </div>
                </FormValidator>

                <FormValidator id="form-group-url" :validator="$v.form.url" form-group :label="$t('urlAddress')">
                    <template #default="slotProps">
                        <b-form-input id="form-url" v-model="form.url" :placeholder="$t('https')" :state="slotProps.state" :disabled="saving" />
                    </template>
                </FormValidator>

                <div class="py-2"></div>

                <b-form-group id="form-group-buybox" :label="$t('widgetBuyBoxConfiguration')">
                    <div class="d-flex gap-3 align-items-center">
                        <b-form-select
                            id="form-buybox"
                            v-model="form.buybox"
                            :options="spaceBuyboxes"
                            text-field="name"
                            value-field="id"
                            :placeholder="$t('defaultConfiguration')"
                            :add-null-option="{ value: null, text: $t('systemic') }"
                            :disabled="requestBuyboxes.getLoading() || saving"
                        />
                        <b-link v-if="buybox" :to="{ name: 'WidgetSettings' }" class="text-nowrap">{{ $t('manageConfigurations') }}</b-link>
                        <b-link v-else :to="{ name: 'WidgetSettings', query: { add: true }}" class="text-nowrap">{{ $t('addOwnConfiguration') }}</b-link>
                    </div>
                </b-form-group>

                <div class="py-2"></div>

                <b-form-group id="form-your-links" :label="$t('yourLinks')">
                    <div class="d-flex flex-column gap-3">
                        <div v-for="(item, index) in form.links" :key="index" class="d-flex gap-3">
                            <FormValidator :id="`form-group-links-${index}-anchor`" class="d-flex flex-column flex-grow-1 flex-shrink-0 flex-basis-0" :validator="$v.form[`links-${index}-anchor`]" v-slot="slotProps">
                                <b-form-input :id="`form-links-${index}-anchor`" v-model="form.links[index].anchor" :placeholder="$t('title')" :disabled="saving" :state="slotProps.state" />
                            </FormValidator>
                            <FormValidator :id="`form-group-links-${index}-url`" class="d-flex flex-column flex-grow-2 flex-shrink-0 flex-basis-0" :validator="$v.form[`links-${index}-url`]" v-slot="slotProps">
                                <b-form-input :id="`form-links-${index}-url`" v-model="form.links[index].url" :placeholder="$t('https')" :disabled="saving" :state="slotProps.state" />
                            </FormValidator>
                        </div>
                    </div>
                </b-form-group>

                <div class="py-2"></div>

                <FormValidator id="form-group-text" :validator="$v.form.text" :label="$t('additionalText')">
                    <template #default="slotProps">
                        <b-form-textarea id="form-text" v-model="form.text" :state="slotProps.state" :disabled="saving" maxlength="300" />
                    </template>
                </FormValidator>

                <div class="py-2"></div>

                <b-form-group id="form-group-ga-id" :label="$t('googleAnalyticsId')">
                    <b-form-input id="form-ga-id" v-model="form.gaId" :placeholder="$t('gaPlaceholder')" :disabled="saving" />
                </b-form-group>

                <div class="py-2"></div>

                <ButtonIcon :loading="saving" :disabled="loading" @click="formSubmit()">
                    {{ $t('saveChanges') }}
                </ButtonIcon>

            </Card>

            <div class="d-none d-md-flex flex-column flex-grow-1 flex-basis-0 card">
                <div class="d-flex justify-content-center align-items-center bg-soft-secondary px-5 py-3 rounded-top">
                    <div class="d-flex justify-content-center align-items-center gap-2 bg-white p-2 width-max-500 flex-grow-1 rounded text-secondary">
                        <ImageLoader v-if="landingPage && landingPage.favicon" :src="landingPage.favicon" height="16px" width="16px" />
                        <span>https://gdziekupic.to</span>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center flex-grow-1 overflow-hidden">

                    <LandingPagePreview
                        v-if="!loading && spaceId"
                        ref="LandingPagePreview"
                        :sid="spaceId"
                        :oid="0"
                        :lp="1"
                        :class="{'w-100': !widgetLoading}"
                        @BBLoading="widgetLoading = true"
                        @NoData="widgetLoading = false"
                        @BBLoaded="widgetLoading = false"
                    />

                    <b-spinner v-if="widgetLoading" />

                </div>

            </div>

        </div>

    </div>
</template>



<script>
    import { helpers, required, maxLength } from 'vuelidate/lib/validators';
    import pick from 'lodash/pick';
    import { serialize as objectToFormData } from 'object-to-formdata';
    import cloneDeep from 'lodash/cloneDeep';
    import LandingPagePreview from '@/components/common/LandingPagePreview.vue';
    import FormValidator from '@/components/common/FormValidator.vue';
    import FormFile from '@/components/common/FormFile.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import { image, url } from '@/utils/validators';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';

    const FORM_DEFAULT_DATA = Object.freeze({
        url: '',
        links: [
            { url: '', anchor: '' },
            { url: '', anchor: '' },
            { url: '', anchor: '' },
        ],
        text: '',
        gaId: '',
        buybox: null,
    });

    const FORM_IMAGES_DEFAULT_DATA = Object.freeze({
        favicon: null,
        logo: null,
    });

    export default {
        name: 'SettingsEdit',
        components: {
            LandingPagePreview,
            FormValidator,
            FormFile,
            ImageLoader,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            const paramsId = Number.parseInt(this.$route.params.id);
            return {
                id: paramsId,
                requestLandingPage: this.$req('landingPage/spacesLandingPage'),
                requestImages: this.$req('landingPage/spacesImages'),
                requestBuyboxes: this.$req('buyboxes/publishers'),
                widgetLoading: false,
                form: cloneDeep(FORM_DEFAULT_DATA),
                formImages: cloneDeep(FORM_IMAGES_DEFAULT_DATA),
            };
        },
        validations() {
            return {
                form: {
                    favicon: { image: value => !helpers.req(value) || image(value) },
                    logo: { image: value => !helpers.req(value) || image(value) },
                    url: { required, url: value => !helpers.req(value) || url(value) },
                    text: { maxLength: maxLength(300) },
                    ...this.form.links.reduce(
                        (acc, item, index) => ({
                            ...acc,
                            ...{
                                [`links-${index}-anchor`]: {
                                    required: () => (item.url ? required(item.anchor) : true),
                                },
                                [`links-${index}-url`]: {
                                    required: () => (item.anchor ? required(item.url) : true),
                                    url: () => (item.url ? url(item.url) : true),
                                },
                            },
                        }),
                        {}
                    ),
                },
                formImages: {
                    favicon: { image: value => !helpers.req(value) || image(value) },
                    logo: { image: value => !helpers.req(value) || image(value) },
                },
            };
        },
        computed: {
            spaceId() {
                return this.id;
            },
            landingPage() {
                return this.requestLandingPage.getData();
            },
            loading() {
                return this.requestLandingPage.getLoading();
            },
            saving() {
                return this.requestLandingPage.getLoading('patch');
            },
            error() {
                return this.requestLandingPage.getError();
            },
            buybox() {
                return this.landingPage?.buybox;
            },
            buyboxId() {
                return this.buybox?.id;
            },
            faviconUrl() {
                return this.form.favicon ? window.URL.createObjectURL(this.form.favicon) : '';
            },
            logoUrl() {
                return this.form.logo ? window.URL.createObjectURL(this.form.logo) : '';
            },
            urlParams() {
                return { id: this.id };
            },
            spaceBuyboxes() {
                return (this.requestBuyboxes.getData() || []).filter(item => item.space.id === this.spaceId).sort((a, b) => a.id > b.id);
            },
        },
        methods: {
            fetchBuyboxes() {
                return this.requestBuyboxes.get({ urlParams: { id: this.$store.getters['auth/getUser'].id } }).catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            fetchLandingPage() {
                return this.requestLandingPage.get({ urlParams: this.urlParams }).then(this.initFormData);
            },
            initFormData() {
                const form = deepMergeWithFilter(FORM_DEFAULT_DATA, this.landingPage);
                form.buybox = this.buyboxId || null;
                form.links = cloneDeep(FORM_DEFAULT_DATA.links.map((link, index) => form.links[index] || link));
                this.form = form;
            },
            initFormImagesData() {
                this.formImages = deepMergeWithFilter(FORM_IMAGES_DEFAULT_DATA, {});
            },
            async formSubmit() {
                this.$v.form.$touch();
                this.$v.formImages.$touch();
                if (this.$v.form.$invalid || this.$v.formImages.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                try {
                    await this.saveForm();
                    await this.saveImages();
                } catch (error) {
                    // error
                } finally {
                    this.fetchLandingPage();
                    this.$refs.LandingPagePreview?.reloadLandingPage();
                }
            },
            saveForm() {
                const apiParams = {
                    urlParams: this.urlParams,
                    requestParams: {
                        ...pick(this.form, ['url', 'text', 'gaId', 'buybox']),
                        links: this.form.links.filter(({ url, anchor }) => url && anchor), // eslint-disable-line
                    },
                };
                return this.requestLandingPage
                    .id('patch')
                    .patch(apiParams)
                    .then(data => {
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$v.form.$reset();
                        return data;
                    })
                    .catch(error => {
                        this.$toastr.error(error.message, this.$t('errorOccurred'));
                        return error;
                    });
            },
            saveImages() {
                if (!this.formImages.favicon && !this.formImages.logo) {
                    return Promise.resolve();
                }
                const apiParams = {
                    urlParams: this.urlParams,
                    requestParams: objectToFormData(pick(this.formImages, ['favicon', 'logo'])),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                return this.requestImages
                    .post(apiParams)
                    .then(data => {
                        this.initFormImagesData();
                        this.$v.formImages.$reset();
                        return data;
                    })
                    .catch(error => {
                        this.$toastr.error(error.message, this.$t('errorOccurred'));
                        return error;
                    });
            },
        },
        async created() {
            await this.fetchLandingPage();
            this.fetchBuyboxes();
        },
    };
</script>



<style lang="scss" scoped>
    ::v-deep .grid-template {
        display: grid;
        grid-template-columns: minmax(60px, max-content) auto;
        gap: 1rem;
        align-items: center;

        .label {
            font-weight: bold;
        }
    }
</style>
